





























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { disciplineOnlineBookingConfigFields } from '@/config/online-booking-config';

@Component({
  name: 'bpc-slot-duration-selector',
  components: {},
})
export default class SlotDurationSelector extends Vue {
  @Prop(Number) readonly value: number;
  @Prop(Array) readonly allowedSlotDurations: number[];

  showModal = false;

  get model() {
    return this.value;
  }

  set model(value: number) {
    this.$emit('input', value);
  }

  get options() {
    return disciplineOnlineBookingConfigFields.allowed_durations.options.filter(option =>
      this.allowedSlotDurations.includes(option.value),
    );
  }

  get selectedOptionLabel() {
    return disciplineOnlineBookingConfigFields.allowed_durations.options.find(
      option => option.value === this.model,
    )?.text;
  }

  selectSlotDuration(duration: number) {
    this.model = duration;
    this.showModal = false;
  }
}
